"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeviceIconUnused = void 0;
var _react = _interopRequireDefault(require("react"));
var _desktopLg = _interopRequireDefault(require("./images/desktop-lg.svg"));
var _desktopMd = _interopRequireDefault(require("./images/desktop-md.svg"));
var _desktopSm = _interopRequireDefault(require("./images/desktop-sm.svg"));
var _mobileLg = _interopRequireDefault(require("./images/mobile-lg.svg"));
var _mobileMd = _interopRequireDefault(require("./images/mobile-md.svg"));
var _mobileSm = _interopRequireDefault(require("./images/mobile-sm.svg"));
var ICON_SRC_MAPPER = {
  regular: {
    lg: _desktopLg["default"],
    md: _desktopMd["default"],
    sm: _desktopSm["default"]
  },
  iOS: {
    lg: _mobileLg["default"],
    md: _mobileMd["default"],
    sm: _mobileSm["default"]
  }
};
var BREAKPOINT_SM = 24;
var BREAKPOINT_MD = 60;
var DeviceIconUnused = exports.DeviceIconUnused = function DeviceIconUnused(_ref) {
  var className = _ref.className,
    isIos = _ref.isIos,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 100 : _ref$size;
  return /*#__PURE__*/_react["default"].createElement("img", {
    className: className,
    src: ICON_SRC_MAPPER[isIos ? 'iOS' : 'regular'][size < BREAKPOINT_SM ? 'sm' : size < BREAKPOINT_MD ? 'md' : 'lg'],
    width: size,
    alt: ""
  });
};